// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1maA4","icon":"SortAdornment_icon__1U2Y7","up":"SortAdornment_up__yK3qN","down":"SortAdornment_down__1SXIa","active":"SortAdornment_active__LTeyc"};